import React, {useEffect, useState} from "react";
import {Button, Col, Descriptions, Row, Tooltip} from "antd";
import {EditOutlined, PlusOutlined, ReloadOutlined} from "@ant-design/icons";
import {useStore} from "../../../../hooks/useStore";
import {CreditUpdateModal} from "../modals/creditUpdateModal/CreditUpdateModal";
import {useTranslation} from "react-i18next";
import {CreditLimitUpdateModal} from "../modals/creditLimitUpdateModal/CreditLimitUpdateModal";
import {MinCreditLoadLimitUpdateModal} from "../modals/minCreditLoadLimitUpdateModal/MinCreditLoadLimitUpdateModal";

export const SubcompanyCredit = ({subcompanyId, subCompanyWorkType, recall, ...props}) => {
    const {t} = useTranslation(["subcompanyDetail"]);
    const stores = useStore();
    const isAgency = stores.meStore.checkRole("isAgency");
    const [credit, setCredit] = useState([]);
    const [creditAlertLimit, setCreditAlertLimit] = useState([]);
    const [minCreditLoadLimit, setMinCreditLoadLimit] = useState();
    const [creditLoading, setCreditLoading] = useState(true);
    const [updateCreditModalVisibility, setUpdateCreditModalVisibility] = useState(false);
    const [updateCreditLimitModal, setUpdateCreditLimitModal] = useState(false);
    const [updateMinCreditLoadLimitModal, setUpdateMinCreditLoadLimitModal] = useState(false);
    const loadCredit = async () => {
        setCreditLoading(true);
        const subCompanyResponse = await stores.companyStore.getSubCompany({
            subCompanyId: subcompanyId
        });
        setCredit(subCompanyResponse.data.credit);
        setCreditAlertLimit(subCompanyResponse?.data?.creditAlertLimit);
        setMinCreditLoadLimit(subCompanyResponse?.data?.minCreditLoadLimit);
        setCreditLoading(false);
    };

    const handleUpdateCredit = () => {
        setUpdateCreditModalVisibility(true);
    };

    const handleUpdateCreditLimit = () => {
        setUpdateCreditLimitModal(true);
    };

    const handleUpdateMinCreditLoadLimit = () => {
        setUpdateMinCreditLoadLimitModal(true);
    };

    const closeModals = async (needRefresh = false) => {
        setUpdateCreditModalVisibility(false);
        setUpdateCreditLimitModal(false);
        setUpdateMinCreditLoadLimitModal(false);
        if (needRefresh) {
            await loadCredit();
        }
    };

    useEffect(() => {
        loadCredit();
    }, []);

    const showAddCreditButton = () => {
        if (credit != null && credit != 9999999) return true;

        return false;
    };

    return (
        <>
            <Col {...props}>
                <Row
                    type="flex"
                    justify="space-between"
                    style={{
                        fontSize: "16px",
                        fontWeight: "700",
                        marginTop: "30px",
                        marginBottom: "20px"
                    }}
                >
                    {t("subcompanyDetail.credit.credit", {ns: "subcompanyDetail"})}
                    <Row type="flex" justify="end" gutter={4}>
                        <Tooltip
                            title={t("subcompanyDetail.credit.action.refresh", {
                                ns: "subcompanyDetail"
                            })}
                        >
                            <Col>
                                <Button
                                    type="primary"
                                    icon={<ReloadOutlined />}
                                    onClick={loadCredit}
                                    loading={creditLoading}
                                />
                            </Col>
                        </Tooltip>
                        {!(isAgency && subCompanyWorkType === "dedicated") &&
                            stores.meStore.checkPermission("subcompanies.manageCredit") && (
                                <Tooltip
                                    placement="topRight"
                                    title={t("subcompanyDetail.credit.addCredit", {
                                        ns: "subcompanyDetail"
                                    })}
                                >
                                    <Col>
                                        <Button
                                            type="primary"
                                            icon={<PlusOutlined />}
                                            onClick={handleUpdateCredit}
                                            loading={creditLoading}
                                            disabled={!showAddCreditButton()}
                                        />
                                    </Col>
                                </Tooltip>
                            )}
                    </Row>
                </Row>
                <Row>
                    <Col span={24}>
                        <Descriptions columns={2} bordered>
                            <Descriptions.Item
                                span={2}
                                label={t("subcompanyDetail.credit.credit", {
                                    ns: "subcompanyDetail"
                                })}
                            >
                                {credit != null && credit != 9999999
                                    ? credit
                                    : t("subcompanyDetail.credit.thisSubcompanyDoesntWorkCredit", {
                                          ns: "subcompanyDetail"
                                      })}
                            </Descriptions.Item>
                        </Descriptions>
                    </Col>
                </Row>
                <Row
                    type="flex"
                    justify="space-between"
                    style={{
                        fontSize: "16px",
                        fontWeight: "700",
                        marginTop: "30px",
                        marginBottom: "20px"
                    }}
                >
                    Kredi Uyarı Limiti
                    <Row type="flex" justify="end" gutter={4}>
                        {stores.meStore.checkPermission("subcompanies.manageCredit") && (
                            <Tooltip placement="topRight" title="Kredi Uyarı Limiti">
                                <Col>
                                    <Button
                                        type="primary"
                                        icon={<EditOutlined />}
                                        onClick={handleUpdateCreditLimit}
                                    />
                                </Col>
                            </Tooltip>
                        )}
                    </Row>
                </Row>
                <Row>
                    <Col span={24}>
                        <Descriptions columns={2} bordered>
                            <Descriptions.Item span={2} label="Kredi Uyarı Limiti">
                                {creditAlertLimit != null ? creditAlertLimit + " TL" : "-"}
                            </Descriptions.Item>
                        </Descriptions>
                    </Col>
                </Row>

                <Row
                    type="flex"
                    justify="space-between"
                    style={{
                        fontSize: "16px",
                        fontWeight: "700",
                        marginTop: "30px",
                        marginBottom: "20px"
                    }}
                >
                    Minimum Kredi Yükleme Limiti
                    <Row type="flex" justify="end" gutter={4}>
                        {stores.meStore.checkPermission("subcompanies.manageCredit") && (
                            <Tooltip placement="topRight" title="Minimum Kredi Yükleme Limiti">
                                <Col>
                                    <Button
                                        type="primary"
                                        icon={<EditOutlined />}
                                        onClick={handleUpdateMinCreditLoadLimit}
                                    />
                                </Col>
                            </Tooltip>
                        )}
                    </Row>
                </Row>
                <Row>
                    <Col span={24}>
                        <Descriptions columns={2} bordered>
                            <Descriptions.Item span={2} label="Minimum Kredi Yükleme Limiti">
                                {minCreditLoadLimit != null ? minCreditLoadLimit + " TL" : "-"}
                            </Descriptions.Item>
                        </Descriptions>
                    </Col>
                </Row>
            </Col>
            <CreditUpdateModal
                subcompanyId={subcompanyId}
                visibility={updateCreditModalVisibility}
                onCancel={closeModals}
            />
            <CreditLimitUpdateModal
                subcompanyId={subcompanyId}
                visibilityState={[updateCreditLimitModal, setUpdateCreditLimitModal]}
                onCancel={closeModals}
            />
            <MinCreditLoadLimitUpdateModal
                subcompanyId={subcompanyId}
                visibilityState={[updateMinCreditLoadLimitModal, setUpdateMinCreditLoadLimitModal]}
                minCreditLoadLimit={minCreditLoadLimit}
                onCancel={closeModals}
            />
        </>
    );
};
